import type { FaireProductEntity } from "../../entity_types/product";

export const p_u3h23g6tzp: FaireProductEntity = {
  token: "p_u3h23g6tzp",
  type: "product",
  name: "Potager Candle",
  brandToken: "b_rk82ea6pnc",
  brandName: "Smeli",
  imageUrl:
    "https://cdn.faire.com/fastly/0882328436b1541f20c644b038a66254f32997915611a016d1f425d95176dfc5.png",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "This is Potager. It's a 9 oz single wick candle in black glass, finished with our signature die cut illustrated label and designed for a clean, steady burn.\n\nFresh tomato leaves mingle with bright lemon peel and fragrant thyme, capturing the quiet beauty of a garden just after sunrise. Crisp, green, and sun warmed, it feels like stepping outside with a basket in hand before the day has fully begun.\n\nLight it with the kitchen windows open.\n\nGarden. Green. Alive.\n\nTomato Leaf | Lemon Peel | Thyme\n\n9 oz\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:44:26.715Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
